import React, {useEffect, useState, useRef } from 'react';
import {
    Layout,
    Input,
    Button,
    Drawer,
    Tabs,
    Form,
    Checkbox,
    Radio,
    Select,
    RadioChangeEvent,
    Spin
} from 'antd';
import {
    PlusOutlined,
    CloseOutlined
} from '@ant-design/icons';
import './index.less';
import moment from 'moment';
import HeaderSearch from '@/components/HeaderSearch';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/redux';
import {
    addUsersAction,
    sendWelcomeEmailListAction,
    updateUserAction
} from '@/redux/reducer/userManagement';
import {getUserList, searchUserInformation, addUsers, sendWelcomeEmail, updateUser } from '@/util/Request';
import TableHeaderCell from '@/components/TableHeaderCell';
import SoilTable from '@/components/SoilTable';
import { IUserManagementAddUsersRequestModel, IUserManagementeSendWelcomeEmailrRequestModel, IUserManagementeUpdateUserRequestModel } from '@/util/Request/requestType';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { updateSuccessMessage, updateWarningMessage } from '@/redux/reducer/common';

const { Content } = Layout;
const { TabPane } = Tabs;
const { Option } = Select;

export default function UserManagement() {
    const { deleteFiled } = useSelector((state: RootState) => state.commonData);
    const [form] = Form.useForm();
    const home = useRef(null);
    //When Administer add a new user, he can decide if inviation mail is needed or not,
    //if (sendInvitationEmail == true) means send Invitation Email
    const [sendInvitationEmail, setSendInvitationEmail] = useState(false);
    const onChangeSend = (e: CheckboxChangeEvent) => {
        console.log(`checked = ${e.target.checked}`);
        setSendInvitationEmail(e.target.checked);
    };
    //get searchUser's parameter
    const [displayName, setdisplayName] = useState('');
    const [mail, setmail] = useState('');
    const [userID, setUserID] = useState('');
    const [givenName, setGivenName] = useState('');
    const [searchText, setSearchText] = useState<string>('');
    const [spining, setSpining] = useState(false);
    const onChanges = (value: string) => {
        console.log('selected $value}', value);
        searchUserInformations.forEach(function (item) {
            if (item.displayName === value) {
                setdisplayName(value);
                setmail(item.mail);
                setUserID(item.onPremisesExtensionAttributes.extensionAttribute1);
                setGivenName(item.givenName);
            }
        });
    };
    //get serachUservalue
    const [serachUservalue, setSerachUservalue] = useState('');
    //Drawer
    const [visible, setVisible] = useState(false);
    const showDrawer = () => {
        dispatch({
            type: 'common/closeDownFile'
        });
        setVisible(true);
    };
    const onClose = () => {
        form.resetFields();
        setmail('');
        setVisible(false);
    };
    const [visible2, setVisible2] = useState(false);
    const onClose2 = () => {
        setVisible2(false);
    };
    const [userIDUpdate, setUserIDUpdate] = useState('');
    const [roleIDUpdate, setRoleIDUpdate] = useState(1);
    const [newRoleIDUpdate, setNewRoleIDUpdate] = useState('');
    const [userIsActiveUpdate, setUserIsActiveUpdate] = useState(true);
    const [userDisplayNameUpdate, setUserDisplayNameUpdate] = useState('');
    const [userEmailUpdate, setUserEmailUpdate] = useState('');
    const [searchUserInformations, setSearchUserInformations] = useState([]);
    const editItem = (param) => {
        dispatch({
            type: 'common/closeDownFile'
        });
        setVisible2(true);
        setUserIDUpdate(param.userId);
        setRoleIDUpdate(param.roleId);
        if (param.roleId == null || param.roleId == '') { setNewRoleIDUpdate(''); }
        else { setNewRoleIDUpdate(param.roleId.toString()); }
        setUserIsActiveUpdate(param.userIsActive);
        setUserDisplayNameUpdate(param.userDisplayName);
        setUserEmailUpdate(param.userEmail);
    };
    //table columns
    const columns = [
        {
            title: () =>
                <TableHeaderCell
                    title='Name'
                    type='sort'
                    sortCallBack={(param) => {
                        console.log('sort button click', param);
                        setDesc(!param);
                    }}
                />,
            dataIndex: 'userDisplayName',
            filterMultiple: false,
            width: '350px',
            render: (text, record, index) => <div className='default-table-height'><a onClick={e => editItem(record)}>{text}</a></div>
        },
        {
            title: 'Email',
            dataIndex: 'userEmail',
            render: (text) => <span>{text}</span>
        },
        {
            title: 'Role',
            dataIndex: 'roleName',
            render: (_, { roleName }) => {
                let color: string;
                if (roleName === 'Administrator') {
                    color = 'administratorColor';
                }
                if (roleName === 'Manager') {
                    color = 'managerColor';
                }
                if (roleName === 'Reader') {
                    color = 'readerColor';
                }
                return (
                    <span className={color} key={roleName}>
                        {roleName}
                    </span>
                );
            }
        },
        {
            title: 'Status',
            dataIndex: 'userIsActive',
            render: (_, { userIsActive }) => {
                let color: string;
                let staus: string;
                if (userIsActive) {
                    color = 'activeColor';
                    staus = 'Active';
                } else {
                    color = 'inactiveColor';
                    staus = 'Inactive';
                }
                return (
                    <span className={color} key={userIsActive}>
                        {staus}
                    </span>
                );
            }
        },
        {
            title: 'Last Login',
            dataIndex: 'userLastLogin',
            render: (_, { userLastLogin }) => {
                const rc = userLastLogin == null ? '' : moment(userLastLogin).format('DD-MM-YYYY h:mm A');
                return (
                    <span>
                        {rc}
                    </span>
                );
            },
            style: 'text-align:right',
        },
    ];

    interface DataType {
        key?: React.Key;
        userId?: string,
        userLoginName?: string,
        userDisplayName: string,
        userEmail: string,
        userIsActive: string,
        userLastLogin?: string,
        roleId?: number,
        roleName?: string
    }
    useEffect(() => {
        getUserLists();
    }, [deleteFiled]);

    //addUser callback
    const [roleID, setroleID] = useState(3);
    const callback = async (key) => {
        console.log('tabKeytabKeytabKey', key);
        setroleID(key);
    };
    //updateUser callbackEdit
    const callbackEdit = async (key) => {
        setNewRoleIDUpdate(key);
        setRoleIDUpdate(key);
    };
    const success = () => {
        addUsersActionU();
        onClose();
    };
    const [refreshFlag, setRefreshFlag] = useState(0);
    const success2 = () => {
        updateUserU();
        onClose2();
    };
    useEffect(() => {
        if (refreshFlag != 0) {
            console.log('cc ', refreshFlag);
            getUserLists();
        }
    }, [refreshFlag]);
    //search
    const searchKeyDown = async (e) => {
        console.log(e);
        setSearchText(e);
        getUserLists(e);
    };
    //tabPosition
    const [tabPosition, setTabPosition] = useState('');
    useEffect(() => {
        console.log('dd userIsActiveUpdate', userIsActiveUpdate);
        if (userIsActiveUpdate === true) {
            console.log('dd tabPosition a', tabPosition);
            setTabPosition('true');
        } else {
            console.log('dd tabPosition b', tabPosition);
            setTabPosition('false');
        }
    }, [userIsActiveUpdate]);
    const changeTabPosition = (e: RadioChangeEvent) => {
        console.log('active and inactive', e.target.value);
        if (e.target.value == 'true') {
            setTabPosition('true');
            setUserIsActiveUpdate(true);
        } else {
            setTabPosition('false');
            setUserIsActiveUpdate(false);
        }
    };
    //=================  define dispatch and get value from store ===================
    const dispatch = useDispatch();
    //const { userList} = useSelector((state: RootState) => state.userManagemnetPageData);
    const [pageIndex, setpageIndex] = useState<number>(1);
    const [desc, setDesc] = useState(false);
    //getUser API
    const [userList, setData] = useState([] as any);
    const getUserLists = async (param = searchText, page = pageIndex) => {
        console.log('searchTextsearchText', searchText);
        console.log('pageIndexpageIndex', pageIndex);
        try {
            const res = await getUserList({
                searchText: param,
                pageIndex: 0,
                pageSize: 15 * page,
                isGetAllUsers: false,
                isSortByNameDesc: false
            });
            setData(res);
            setIsFetching(false);
        } catch (err) {
            setIsFetching(false);
        }
    };
    useEffect(() => {
        getUserLists();
    }, [desc]);

    useEffect(() => {
        getUserLists();
        searchUserInformationAction();
    }, []);

    //searchUserInformation
    const searchUserInformationAction = async (text = serachUservalue) => {
        console.log('tt dd', text);
        if (text.trim().length > 0) {
            setSpining(true);
            const response = await searchUserInformation(text.trim());
            setSearchUserInformations(response);
            setSpining(false);
        }
    };

    const [doudong, setDoudong] = useState(null);
    const onSearchs = async (value: string) => {
        console.log('ttt:', value);
        setSerachUservalue(value);
        if (value != '') {
            clearTimeout(doudong);
            const time = setTimeout(() => {
                console.log('123123');
                searchUserInformationAction(value);
                setDoudong(null);
            }, 800);
            setDoudong(time);
        } else {
            clearTimeout(doudong);
            setChildrenSelect([]);
        }
    };

    //option
    const [childrenSelect, setChildrenSelect] = useState<React.ReactNode[]>([]);
    useEffect(() => {
        const tmpChirdern: React.ReactNode[] = [];
        console.log('searchUserInformations', searchUserInformations);
        searchUserInformations.forEach((item, index) => {
            tmpChirdern.push(<Option key={index} value={item.displayName}>{item.displayName}</Option>);
        });
        setChildrenSelect(tmpChirdern);
    }, [searchUserInformations]);

    //addUsers API
    const addUsersActionU = async () => {
        const objs = searchUserInformations.find(item => item.displayName == displayName);
        console.log('add ', objs);
        // IUserManagementAddUsersRequestModel
        const addUserParam: IUserManagementAddUsersRequestModel = {
            userID: userID,
            email: mail,
            displayName:
                displayName,
            roleID: roleID,
            firstName: objs?.givenName,
            lastName: objs?.surname
        };
        const response = await addUsers(addUserParam);
        console.log('addUsersActionUaddUsersActionUaddUsersActionU', response);
        if (response === 'Success') {
            setRefreshFlag(refreshFlag + 1);
            dispatch(updateSuccessMessage('New user added succesfully'));
            sendInvitationEmail && sendWelcomeEmailListU();
        }
        if (response === 'This user already exists.') {
            dispatch(updateWarningMessage('This user already exists.'));
        }
        dispatch(addUsersAction({
            userList: [], downloadUserLists: [], deleteFileBoolean: true,
            searchUserInformations: [], addUserList: response, sendWelcomeEmailList: [], updateUserList: []
        }));
    };
    const sendWelcomeEmailListU = async () => {
        // IUserManagementeSendWelcomeEmailrRequestModel
        const sendWelcomeEmailParam: IUserManagementeSendWelcomeEmailrRequestModel = { userEmail: mail, userFirstName: givenName };
        const response = await sendWelcomeEmail(sendWelcomeEmailParam);
        dispatch(sendWelcomeEmailListAction({
            userList: [], downloadUserLists: [], deleteFileBoolean: true,
            searchUserInformations: [], addUserList: [], sendWelcomeEmailList: response, updateUserList: []
        }));
    };
    //updateUser
    const updateUserU = async () => {
        const updateUserParam: IUserManagementeUpdateUserRequestModel = { userID: userIDUpdate, roleID: roleIDUpdate, userIsActive: userIsActiveUpdate };
        const response = await updateUser(updateUserParam);
        console.log('updateUserupdateUserupdateUser', response);
        if (response === 'Success') {
            setRefreshFlag(refreshFlag + 1);
            dispatch(updateSuccessMessage('User data has been changed'));
        }
        dispatch(updateUserAction({
            userList: [], downloadUserLists: [], deleteFileBoolean: true,
            searchUserInformations: [], addUserList: [], sendWelcomeEmailList: [], updateUserList: response
        }));
    };

    const [isFetching, setIsFetching] = useState(false);
    useEffect(() => {
        window.addEventListener('scroll', () => handleScroll());
        return () => window.removeEventListener('scroll', () => handleScroll());
    }, []);
    const handleScroll = () => {
        if (window.innerHeight + document.documentElement.scrollTop > document.body.scrollHeight - 50) {
            console.log('fech more items', pageIndex);
            setIsFetching(true);
        } else {
            console.log('unreach');
        }
    };
    useEffect(() => {
        if (!isFetching) return;
        setpageIndex(pageIndex + 1);
        getUserLists(searchText, pageIndex + 1);
    }, [isFetching]);
//   { label: 'Tab 2', key: 'item-2', children: 'Content 2' },
    const items = [
        {
            label: 'Reader',
            key: '3',
            children: <p>Reader only has the right to search and view the data</p>,
            style: { fontFamily: 'Noto-Sans', fontSize: '12px', color: '#696F88', width: '100%', lineHeight: '16px'}
        },
        {
            label: 'Manager',
            key: '2',
            children: <p>{`Manager has the right to search, view, edit and create the Soil Profiles,${''} Soil Analysis and Templates`}</p>,
            style: { fontFamily: 'Noto-Sans', fontSize: '12px', color: '#696F88', lineHeight: '16px' },
        },
        {
            label: 'Administration',
            key: '1',
            children: <p>{`The administrator has the right to search, view, edit and create data.${''} They can also manage users`}</p>,
            style: { fontFamily: 'Noto-Sans', fontSize: '12px', color: '#696F88', lineHeight: '16px' }
        },
    ];

    return (
        <div ref={home} className="user-management-content" style={{ width: '100%', height: '640px' }}>
            <div
                className="site-layout-background"
            >
                {/* Drawer: New User */}
                <Drawer
                    placement="right"
                    closeIcon={null}
                    open={visible}
                    style={{ overflow: 'hidden' }}>
                    <div className='title-close-div'>
                        <span>New User</span>
                        <button style={{ backgroundColor: 'white' }} onClick={() => onClose()}><CloseOutlined style={{ cursor: 'pointer' }} /></button>
                    </div>

                    <h4 style={{ fontSize: '14px', margin: '20px 0 28px 0', fontWeight: 700 }}>User Details</h4>
                    <p style={{ marginBottom: '0px', fontWeight: 400, color: '#14151C' }}>Role</p>
                    <Tabs onChange={callback} type="card" className="tab-soil" items={items} />
                    {/* <Tabs onChange={callback} type="card" className="tab-soil">
                        <TabPane tab="Reader" key="3" style={{ fontFamily: 'Noto-Sans', fontSize: '12px', color: '#696F88', lineHeight: '16px' }}>
                            <p>Reader only has the right to search and view the data</p>
                        </TabPane>
                        <TabPane tab="Manager" key="2" style={{ fontFamily: 'Noto-Sans', fontSize: '12px', color: '#696F88', lineHeight: '16px' }}>
                            <p>{`Manager has the right to search, view, edit and create the Soil Profiles,${''} Soil Analysis and Templates`}</p>
                        </TabPane>
                        <TabPane tab="Administration" key="1" style={{ fontFamily: 'Noto-Sans', fontSize: '12px', color: '#696F88', lineHeight: '16px' }}>
                            <p>{`The administrator has the right to search, view, edit and create data.${''} They can also manage users`}</p>
                        </TabPane>
                    </Tabs> */}
                    <Form
                        id="Form"
                        // name="basic"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{ marginTop: '20px' }}
                        form={form}
                    >
                        <Form.Item style={{ marginBottom: '10px', fontWeight: 400, color: '#14151C', fontFamily: 'Noto-Sans-Regular' }}
                            label="Name"
                            // name="name"
                        >
                            {/*<Input placeholder="user.name" />*/}
                            <Spin spinning={spining}>

                                <Select
                                    size='large'
                                    showSearch
                                    placeholder="Select a person"
                                    optionFilterProp="children"
                                    onChange={onChanges}
                                    onSearch={onSearchs}
                                    onBlur={e => setChildrenSelect([])}
                                >
                                    {childrenSelect}
                                </Select>
                            </Spin>

                        </Form.Item>
                        <Form.Item
                            label="Email"
                            // name="email"
                            style={{ fontWeight: 400, color: '#14151C', fontFamily: 'Noto-Sans-Regular' }}
                        >
                            <Input size='large' placeholder="user.name@domain.com" value={mail} disabled /><span style={{ display: 'none' }}>{mail}</span>
                        </Form.Item>
                    </Form>
                    <Checkbox onChange={onChangeSend}>
                        <span style={{ color: '#696F88' }}>Send invitation email</span>
                    </Checkbox>
                    <Form style={{ marginTop: '40px', float: 'right' }}>
                        <Button
                            onClick={onClose}
                            size='large'
                            style={{ margin: '0 10px', borderRadius: '24px' }}>Cancel</Button>
                        <Button
                            type="primary"
                            onClick={success}
                            size='large'
                            style={{
                                background: '#59B948',
                                borderRadius: '24px',
                                border: '1px solid #59B948'
                            }}>
                            Save
                        </Button>
                    </Form>
                </Drawer>
                {/* Drawer:Edit User */}
                <Drawer
                    // title="New User"
                    placement="right"
                    // onClose={onClose}
                    closeIcon={null}
                    open={visible2}
                    style={{ overflow: 'hidden' }}>
                    <div className='title-close-div'>
                        <span>Edit User</span>
                        <button style={{ backgroundColor: 'white' }} onClick={() => onClose2()}><CloseOutlined style={{ cursor: 'pointer' }} /></button>
                    </div>
                    <h4 style={{ fontSize: '14px', margin: '20px 0 28px 0', fontWeight: 700 }}>User Details</h4>
                    <p style={{ marginBottom: '0px', fontWeight: 400, color: '#14151C' }}>Role</p>
                    <Tabs onChange={callbackEdit} type="card" activeKey={newRoleIDUpdate} className="tab-soil" items={items} />
                    {/* <Tabs onChange={callbackEdit} type="card" activeKey={newRoleIDUpdate} className="tab-soil">
                        <TabPane tab="Reader" key="3" style={{ fontFamily: 'Noto-Sans', fontSize: '12px', color: '#696F88', lineHeight: '16px' }}>
                            <p>Reader only has the right to search and view the data</p>
                        </TabPane>
                        <TabPane tab="Manager" key="2" style={{ fontFamily: 'Noto-Sans', fontSize: '12px', color: '#696F88', lineHeight: '16px' }}>
                            <p>{`Manager has the right to search, view, edit and create the Soil Profiles,${''} Soil Analysis and Templates`}</p>
                        </TabPane>
                        <TabPane tab="Administration" key="1" style={{ fontFamily: 'Noto-Sans', fontSize: '12px', color: '#696F88', lineHeight: '16px' }}>
                            <p>{`The administrator has the right to search, view, edit and create data.${''} They can also manage users`}</p>
                        </TabPane>
                    </Tabs> */}
                    <Form
                        id="Form"
                        name="basic"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{ marginTop: '20px' }}
                    >
                        <Form.Item style={{ marginBottom: '10px', color: '#14151C', fontFamily: 'Noto-Sans-Regular' }}
                            label="Name"
                            name="name"
                        >
                            <Input size='large' placeholder="user.name" value={userDisplayNameUpdate} disabled /><span style={{ display: 'none' }}>{userDisplayNameUpdate}</span>
                        </Form.Item>
                        <Form.Item
                            label="Email"
                            name="email"
                        >
                            <Input size='large' placeholder="user.name@domain.com" value={userEmailUpdate} disabled /><span style={{ display: 'none' }}>{userEmailUpdate}</span>
                        </Form.Item>
                    </Form>
                    {/* <Checkbox onChange={onChange}>Send invitation email</Checkbox>*/}
                    <p style={{ marginBottom: '0px', color: '#14151C' }}>Status</p>
                    <Radio.Group className='tab-soil' value={tabPosition} onChange={changeTabPosition}
                        style={{ marginBottom: 16 }} size='large'>
                        <Radio.Button value="true">Active</Radio.Button>
                        <Radio.Button value="false">Inactive</Radio.Button>
                    </Radio.Group>
                    <Form style={{ marginTop: '40px', float: 'right' }}>
                        <Button
                            onClick={onClose2}
                            size='large'
                            style={{ margin: '0 10px', borderRadius: '24px' }}>
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            onClick={success2}
                            size='large'
                            style={{
                                background: '#59B948',
                                borderRadius: '24px',
                                border: '1px solid #59B948'
                            }}>
                            Save
                        </Button>
                    </Form>
                </Drawer>
                <h3 className='soliHeader'>
                    User Management
                </h3>
                {/* Search and addUser */}
                <div className='management-search-div' style={{
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <div>
                        <HeaderSearch GetAnalyses={searchKeyDown} placeholder='Search' />
                    </div>
                    <div style={{ marginRight: '25px' }}>
                        <Button
                            icon={<PlusOutlined />}
                            style={{
                                border: '1px solid #009933',
                                color: '#FFF',
                                height: '40px',
                                verticalAlign: 'baseline',
                                backgroundColor: '#59B948',
                                borderRadius: '24px'

                            }}
                            onClick={showDrawer}>
                            Add User
                        </Button>
                    </div>
                </div>
                <div className="tableBox">
                    <Content style={{ backgroundColor: '#fff' }}>
                        <SoilTable
                            rowKey={record => record.userId}
                            columns={columns}
                            dataSource={userList}
                            pagination={false}
                            hideSelectAll={true}
                        />
                    </Content>
                </div>
            </div>
        </div>
    );
}
